/**
 * @file 后台顶栏右侧操作区
 * @description 主题入口 + 用户菜单的组合。
 *
 * @whenToUse AdminShell 顶栏右侧默认内容。
 * @whenNotToUse 业务页内工具栏操作（用 Button / IconButton 自行组合）。
 */

import { AdminUserMenu } from '@/components/admin-user-menu.tsx'
import { ThemeSwitcherDialog } from '@/components/theme-switcher-dialog.tsx'
import { useUserStore } from '@/stores/user-store.ts'

/**
 * 顶栏右侧：剩余点数 + 主题切换弹窗 + 用户菜单。
 * 用户名与点数来自 `/system/user/getInfo`（user-store）。
 */
export function AdminTopbarActions() {
  const user = useUserStore((s) => s.user)
  const username = user?.nickName || user?.userName || '未登录'
  const points = user?.points ?? 0

  return (
    <>
      <div className="text-sm inline-flex items-center">点数：<span className="text-primary font-medium">{points}</span></div>
      <ThemeSwitcherDialog />
      <AdminUserMenu username={username} points={points} />
    </>
  )
}
